/* global d3 $ _ */ /* eslint-disable-line */
import pipeService from '../../service/pipeService' /* eslint-disable-line */
import globalConfig from '../../service/globalConfig';
import "../../assets/controlpanel.scss";

let DrawUserFilter = function(id) {
    const _this = this;
    _this.id = id;

    _this.svgWidth = $('#' + id).width();
    _this.svgHeight = $('#' + id).height();

    _this.marginLR = 10; // svg margin left & right 
    _this.marginTB = 5; // svg margin top & bottom

    _this.gtWidth = _this.svgWidth - 2 * _this.marginLR;
    _this.gHeight = _this.svgHeight - 2 * _this.marginTB;

    /////////////////////////////////////////////////////////////
    // query context
    /////////////////////////////////////////////////////////////
    _this.querysentence = d3.select("#querysentence");

    /////////////////////////////////////////////////////////////
    // response context
    /////////////////////////////////////////////////////////////
    _this.responsesentence = d3.select("#responsesentence");
    // response multiline table
    _this.tableH = "150px";

    /////////////////////////////////////////////////////////////
    // draw legends
    /////////////////////////////////////////////////////////////
    let legend = d3.select('#feature-glyphs');
    // key techs
    let keytechs = ["Repetition", "Disconnection", "Polarity", "Subjectivity", "Alliterations", "Rhymes", "Louder", "Softer", "Stress", "Pause", "Faster", "Slower"];

    // --- UPDATE: Sep. 12, 2020
    // --- add tooltips information for each feature
    let techtips = ["Repeating similar objects in a sentence", "Disconnection (e.g., contrast) of one idea from another in a sentence",
        "Positive/negative orientation of emotion", "Subjective/objective orientation",
        "Occurrences of the same letter or sound at the beginning of a group or words", "Repetition of similar sounds in the final stressed syllables of a group of words",
        "Volume gets higher", "Volume gets softer", "vocal stress by raising pitch", "temporary stop or rest", "speed up", "slow down"
    ]

    keytechs.map(function(k, ki) {

        let legendDiv = legend.append("div").attr("class", "featureLegend").attr("data-toggle", "tooltip").attr("title", techtips[ki]);
        // label name
        legendDiv.append("div")
            .style("font-weight", "bold")
            .text(k);

        // glyphs
        legendDiv.append("div")
            .style("color", globalConfig.allTechColor[k.toLowerCase()])
            .html(globalConfig.allTechHtmls[k.toLowerCase()])
    });

    $("[data-toggle='tooltip']").tooltip();
}

DrawUserFilter.prototype.layout = function(data, contexts, segData) { /* eslint-disable-line */
    function firstUpperCase(str) { /* eslint-disable-line */
        return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
    }

    const _this = this; /* eslint-disable-line */
    // console.log("--- inside draw layout: ---");
    // console.log("data:",data);
    // --- reset
    _this.querysentence.selectAll("*").remove();
    // _this.contentMultiLine.selectAll("*").remove();
    _this.responsesentence.selectAll("*").remove();

    // --- punchline query
    let squery = data["query"]["segment"];
    let pquery = squery["sentences"][squery["sentences"].length - 1];
    console.log("punchline:", pquery);

    let querydiv = _this.querysentence.append("div")
        .attr("class", "querydiv");
    // draw query sentence
    pquery.structure.tokens.map(function(w) {
        querydiv.append("div")
            .attr("class", "qword")
            .html(w.text);
    });

    // draw response sentence
    // --- config

    let contextH = 100;
    let senMaxL = 30;
    let senMinL = 10;
    let xSenScale = d3.scaleLinear().range([senMinL, senMaxL]); /* eslint-disable-line */
    let contextBarH = 4;
    let contextSummaryY = 35;
    let senH = 10;

    ///////////////////////////////////
    let line = d3.line()
        .x(function(d) { return d[0]; }) // set the x values for the line generator
        .y(function(d) { return d[1]; }) // set the y values for the line generator 
        .curve(d3.curveMonotoneX); // apply smoothing to the line
    ///////////////////////////////////

    // --- response config
    let response = data.response;
    let responsediv = _this.responsesentence.append("div");

    // --- get sentence length range
    let senLens = [];
    response.segments.map(function(seg) {
        seg.map(function(s) {
            if (s.hasOwnProperty("structure")) {
                senLens.push(s.structure.tokens.length)
            }
        });
    });
    // console.log("sentence length:",senLens);
    xSenScale.domain(d3.extent(senLens));

    ///////////////////////////////////
    // --- draw all contexts in the responses (array)
    ///////////////////////////////////

    response.segments.map(function(seg, id) {
        let rsentence = seg[seg.length - 1];
        // console.log("response sentence:", rsentence);
        let rowdiv = responsediv.append("div").attr("class", "rowdiv-" + id.toString());

        ///////////////////////////////////////////////////
        // draw context summary
        ///////////////////////////////////////////////////
        // --- 1 draw punchline contexts
        let rowcontextdiv = rowdiv.append("div").attr("class", "d-flex flex-row align-items-center")
            .append("div")
            .attr("class", "rowsummary");

        let growcontext = rowcontextdiv.append("svg")
            // .attr("class","")
            // .attr("width",$("#responsesentence").width())
            .attr("width", 3000)
            .attr("height", contextH)
            .append("g")
            .attr("transform", "translate(5,5)");

        ///////////////////////////////////////////////////
        let rowtexts = rowdiv.append("div").attr("class", "d-flex flex-row") /* eslint-disable-line */
            .append("div")
            .attr("class", "rowtext")
            .append("div");

        // console.log("context linking:", contexts[id]);
        // --- get current context info
        // --- 1.1 draw context summary
        let sxoffset = 0;
        let senxDict = {}; // --- record sentence xoffset
        // --- context sentence rect group
        let contextsenrect = growcontext.append("g").attr("class", "contextsenrect");
        // --- repetitionbar rect group
        let reprect = growcontext.append("g").attr("class", "reprect");
        seg.map(function(s, senid) {
            ////////////////////////////////////////////////
            // --- get sentence techniques
            if (s.hasOwnProperty("startTime")) {
                let senSkills = globalConfig.extractHumorskills(s, segData[id]);
                s['senSkills'] = senSkills;
            }

            ////////////////////////////////////////////////
            let senClass = "senrect";
            if (senid == seg.length - 1) {
                senClass = "punchrect";
            }

            if (s.hasOwnProperty("structure")) {
                // --- 1.1.1 draw sentence rectangle in context summary
                contextsenrect.append("rect")
                    .attr("class", senClass)
                    .attr("x", sxoffset)
                    .attr("y", contextSummaryY)
                    .attr("rx", 2)
                    .attr("ry", 2)
                    .attr("width", xSenScale(s.structure.tokens.length))
                    .attr("height", senH);
                // --- 1.1.2 draw repetitionbar
                if (contexts[id].hasOwnProperty("sentence_story")) {
                    let sentence_story = contexts[id]["sentence_story"];
                    if (sentence_story.hasOwnProperty(senid.toString())) {
                        // console.log("context ",id, "sentence ", senid, sentence_story[senid.toString()].length);
                        let reptition = sentence_story[senid.toString()].length; // --- repetition
                        let y = contextSummaryY + senH + 2;
                        for (let i = 0; i < reptition; i++) {
                            reprect.append("rect")
                                .attr("class", "repetitionBar")
                                .attr("x", sxoffset)
                                .attr("y", y)
                                // .attr("rx", 2)
                                // .attr("ry", 2)
                                .attr("width", xSenScale(s.structure.tokens.length))
                                .attr("height", contextBarH);
                            y = y + contextBarH + 1;
                        }

                    }

                }
                // ---
                senxDict[senid.toString()] = sxoffset + 1 / 2 * xSenScale(s.structure.tokens.length);
                // --- sentence offset
                sxoffset = sxoffset + xSenScale(s.structure.tokens.length) + 5;
            }
        });
        // --- 1.1.3 draw links
        if (contexts[id].hasOwnProperty("word_story")) {
            let word_story = contexts[id]["word_story"];
            let gcontextpath = growcontext.append("g").attr("class", "contextpath");
            Object.keys(word_story).map(function(ws) {
                let repgroup = word_story[ws];
                repgroup.map(function(g, gi) {
                    if (gi < repgroup.length - 1) {
                        let x0 = senxDict[g[2].toString()];
                        let y0 = contextSummaryY;
                        let x1 = senxDict[repgroup[gi + 1][2].toString()];
                        let y1 = contextSummaryY;
                        let dsenid = Math.abs(parseInt(g[2].toString(), 10) - parseInt(repgroup[gi + 1][2].toString(), 10));
                        let x2 = (x0 + x1) / 2;
                        let y2 = y0;
                        // console.log("link pos:",x0,x1,x2)
                        if (dsenid > 7) {
                            y2 = y0 - 35;
                        } else {
                            y2 = y0 - dsenid * 5;
                        }
                        let tPos = [
                            [x0, y0],
                            [x2, y2],
                            [x1, y1],
                        ];
                        // --- 1.1.4 draw group links
                        gcontextpath
                            .append("path")
                            // class 1: segmentid, wordgroupid
                            .attr("class", "wordlinks")
                            .data([tPos])
                            .attr("d", line);
                    }
                });
            });

        }
        // --- 1.1.4 draw words
        // rowtexts
        if (contexts[id].hasOwnProperty("sentence_story")) {
            let sentence_story = contexts[id]["sentence_story"];
            let sentence_ids = Object.keys(sentence_story);
            sentence_ids.sort(function(a, b) {
                    return parseInt(a, 10) - parseInt(b, 10);
                })
                // console.log("sentence sorting:", sentence_ids);
            sentence_ids.map(function(senid) {
                let senwords = sentence_story[senid];
                rowtexts.append("div")
                    .attr("class", "sentencebreak");
                senwords.map(function(w) {
                    rowtexts.append("div")
                        .attr("class", "keywords")
                        .html(w[5]);
                });
            });

        }
        ///////////////////////////////////////////////////
        // draw multiline annotated sentence
        ///////////////////////////////////////////////////
        // --- 2. draw multiline texts
        let rowmultiline = rowdiv.append("div").attr("class", "d-flex flex-row align-items-center " + "rowmultilines"); /* eslint-disable-line */
        rowmultiline.append("div")
            .attr("class", "rowsultilineTable")
            .attr("width", $("#responsesentence").width())
            .attr("height", 300);
        rowmultiline.append("div")
            .attr("class", "response-multiLine")
            .attr('id', 'response-multiLine-' + id)
            .style('position', 'relative')
            .style('width', '100%')
            .style('height', _this.tableH);

        ////////////////////////////////////////////////////////////
        // --- draw multiline
        _this.drawContentMultiLine(seg, id);
        ////////////////////////////////////////////////////////////


        ///////////////////////////////////////////////////
        // draw punchline sentence
        ///////////////////////////////////////////////////
        // --- 3. draw punchline text
        let rowtextdiv = rowdiv.append("div").attr("class", "d-flex flex-row align-items-center " + "rowpunchline");
        // --- response id
        rowtextdiv.append("div").attr("class", "p").append("div")
            .attr("class", "responseid")
            .html(id.toString() + ".");
        // --- response sentence div
        let resendiv = rowtextdiv.append("div").attr("class", "p").append("div")
            .attr("class", "responsediv");

        if (rsentence.hasOwnProperty("structure")) {
            rsentence.structure.tokens.map(function(w) {
                resendiv.append("div")
                    .attr("class", "responseword")
                    .html(w.text);
            });
        }



    });

    $("#responsesentence").height($("#humordetailContainer").height() - $("#querysentence").height() - 20);

    ////////////////////////////////////////////////////////////
    // adjust multiline table (height,scroll)
    ////////////////////////////////////////////////////////////
    $(".response-multiLine").each(function() {
        $(this).scrollTop($(this)[0].scrollHeight);
        // adjust table Height
        let tableH = $(this).height();
        let contentH = $('> table', this).height();
        if (tableH > contentH) {
            $(this).height(contentH);
        }
    });

    ////////////////////////////////////////////////////////////
    // adjust svg width height
    ////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////
    // adjust svg width height
    ////////////////////////////////////////////////////////////
    $(".rowsummary svg").each(function() {

        let gH = d3.select(this).select("g").node().getBBox().height
        let deltay = Math.abs($(this).position().top - $(this).find("g").position().top)

        d3.select(this)
            .attr("height", d3.select(this).select("g").node().getBBox().height + 4 * 5)
            .attr("viewBox", "0 " + deltay + " " + (3000) + " " + (gH));
    });
};

DrawUserFilter.prototype.drawPreviewContext = function(data) {
    const _this = this
    let punchlines = data['punchlines']
    let sentenceStarTimeList = data['sentenceStarTimeList']
    let bisect = d3.bisector(function(d) { return d }).left

    _this.previewContextContaner.selectAll('*').remove()
    _this.previewContextContaner.append('g')
        .attr('class', 'sentenceContext')
        .append("rect")
        .attr("class", "contextlink")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", _this.previewContextWidth)
        .attr("height", _this.previewContextHeight)
        .style('fill', 'lightyellow')
        .on('click', function() {
            let mouse = d3.mouse(this)
            let clickTime = Math.round(_this.xScaler.invert(mouse[0]))
                // console.log('durationTime: ', durationTime)
            _this.timeslider
                .transition()
                .duration(200)
                .attr('d', () => {
                    let d = 'M' + mouse[0] + ',' + (-5)
                    d += ' ' + mouse[0] + ',' + (_this.previewContextHeight + 5)
                    return d
                })

            let sentenceIdx = bisect(sentenceStarTimeList, clickTime)
            pipeService.emitLocateSentence(sentenceIdx)
        })

    _this.previewContextContaner.append('g')
        .attr('class', 'punchlines')
        .selectAll('rect')
        .data(punchlines)
        .enter()
        .append('rect')
        .attr('x', (d) => _this.xScaler(d['startTime']))
        .attr('y', 0)
        .attr('width', 2)
        .attr('height', _this.previewContextHeight)
        .style('fill', 'lightblue')
        .style('pointer-events', 'none')

    _this.timeslider = _this.previewContextContaner.append('g')
        .append('path')
        .attr('id', 'timeslider')
        .attr('d', () => {
            let d = 'M' + 0 + ',' + (-5)
            d += ' ' + 0 + ',' + (_this.previewContextHeight + 5)
            return d
        })
        .style('stroke', 'red')
        .style('stroke-width', '1px')
        .style('vector-effect', 'non-scaling-stroke')

}

DrawUserFilter.prototype.drawContentMultiLine = function(data, sid) {
    const _this = this
    let contentMultiLine = d3.select("#response-multiLine-" + sid)
    contentMultiLine.selectAll('*').remove();
    // _this.contentMultiLine.selectAll('*').remove()
    let sentences = data

    let repetitionFlag = {
        'sentenceIdx': -1,
        'repetition': 0
    }
    let disconnectionFlag = {
        'sentenceIdx': -1,
        'disconnection': 0,
    }

    // console.log('sentences: ', sentences)
    // let table = _this.contentMultiLine.append('table')
    let table = contentMultiLine.append('table')
        .attr('class', 'multiline fixHeaderTable')
        .style('position', 'static')
        .style('visibility', 'visible')
        .style('width', '100%')
        // .style('height', '100%')
        .style('table-layout', 'fixed')

    // let thead = table.append('thead').attr('class', 'multiline fixedHeader')
    let tbody = table.append('tbody').attr('class', 'multiline list scrollContent')

    // console.log('thead: ', thead)
    // console.log('tbody: ', tbody)
    let columns = ['sentenceIdx', 'sentenceContext']
        // console.log('columns: ', columns)

    // create a row for each object in the data
    let rows = tbody.selectAll('tr')
        .data(sentences.filter((d) => d.hasOwnProperty("startTime")))
        .enter()
        .append('tr')
        .attr('class', (d, i) => {
            return 'multiline tableRow ' + 'row-' + i
        })
        .attr('selected', false)
        .style('background-color', 'white')

    // console.log('rows: ', rows)

    // create a cell in each row for each column
    rows.selectAll('td')
        .data(function(tableRow, rowIdx) {
            let startTime = tableRow['startTime']
            let endTime = tableRow['endTime']
            return columns.map(function(column) {
                if (column === 'sentenceContext') {
                    return { column: 'sentenceContextExp', value: tableRow, punchlineFlag: tableRow.punchlineFlag, startTime: startTime, endTime: endTime }
                } else if (column === 'sentenceIdx') {
                    return { column: 'sentenceIdxExp', value: rowIdx, punchlineFlag: tableRow.punchlineFlag, startTime: startTime, endTime: endTime }
                }
            })
        })
        .enter()
        .append('td')
        .attr('class', function(d) {
            return d.column
        })
        .style('background-color', function(d) {
            if (d.punchlineFlag && d.column == 'sentenceIdxExp') return 'lightblue'
        })
        .style('width', function(d) {
            if (d.column == "sentenceIdxExp") {
                return "10px";
            } else {
                return '100%';
            }
        })
        .append('div')
        .attr('class', function(d) {
            return 'divContent ' + d.column
        })
        .style('width', "100%")


    d3.selectAll('div.divContent.sentenceIdxExp')
        .html(function(d) {
            return d.value
        })
        .style('user-select', 'none')

    d3.selectAll('div.divContent.sentenceContextExp')
        .selectAll('div.word')
        .data((sentence, sIdx) => {
            //    console.log('sentence: ', sentence['value'])
            let disconnection = 0
            let repetition = 0
            for (let wordIdx = 0; wordIdx < sentence['value']['senSkills'].length; wordIdx++) {
                let wordSkills = sentence['value']['senSkills'][wordIdx]
                if (wordSkills['texthumour']['disconnection'].length > 0) {
                    disconnection += 1
                }
                if (wordSkills['texthumour']['repetition'].length > 0) {
                    repetition += 1
                }
            }

            return d3.range(sentence['value']['senSkills'].length).map((wordIdx) => {
                return {
                    'rowIdx': sIdx,
                    'word': sentence['value']['senSkills'][wordIdx]['text'],
                    'wordSkills': sentence['value']['senSkills'][wordIdx],
                    'senSkills': sentence['value']['senSkills'],
                    'disconnection': disconnection,
                    'repetition': repetition
                }
            })
        })
        .enter()
        .append('div')
        .attr('height', '20px')
        .attr('id', (d, i) => {
            // console.log('d: , word')
            return `word-${d['rowIdx']}-${i}`
        })
        .attr('class', 'word')
        .style('display', 'inline-block')
        .style('position', 'relative')
        .style('margin', '2px')
        .style('padding', '2px')
        .append('div')
        .html(function(d) {
            return d['word']
        })
        .style('user-select', 'none')
        .style('display', 'inline')
        .each(drawEachWord)

    function drawEachWord(wordInfo) {
        // console.log('wordIdx, wordInfo: ', wordInfo)
        ///////////////////////////////////////////////////////////////////////////
        // audio humor
        ///////////////////////////////////////////////////////////////////////////
        let audiohumour = {}
        let audiohumourOrigin = wordInfo['wordSkills']['audiohumour']
        for (let i = 0; i < audiohumourOrigin.length; i++) {
            let audioTech = audiohumourOrigin[i]
            if (typeof(audioTech) == 'string') {
                audiohumour[globalConfig.audioHumorMapping[audioTech]] = audioTech
            } else {
                audiohumour[audioTech[0]] = audioTech[1]
            }
        }
        // console.log('audiohumour: ', audiohumour)

        ///////////////////////////////////////////////////////////////////////////
        // speed
        ///////////////////////////////////////////////////////////////////////////
        let speedSymbol = ""
        let speedColor = "white"
        if (audiohumour.hasOwnProperty('speed')) {
            let speedTech = audiohumour['speed']
            if (speedTech === "slower") {
                speedSymbol = "<<"
            } else if (speedTech === "faster") {
                speedSymbol = ">>"
            }
            if (speedSymbol != "") {
                speedColor = globalConfig.audioColor[speedTech]
            }
        }

        ///////////////////////////////////////////////////////////////////////////
        // volume
        ///////////////////////////////////////////////////////////////////////////
        let volSymbol = ''
        let volColor = 'white'
        if (audiohumour.hasOwnProperty('volume')) {
            // let volColor = 'transparent'
            let volTech = audiohumour['volume']
            volColor = globalConfig.audioColor[volTech]
            if (volTech === "softer") {
                volSymbol = '<i class="fas fa-level-down-alt">'
            } else if (volTech === "louder") {
                volSymbol = '<i class="fas fa-level-up-alt">'
            }
        }

        ///////////////////////////////////////////////////////////////////////////
        // pitch
        ///////////////////////////////////////////////////////////////////////////
        let pitchStyle = ''
        if (audiohumour.hasOwnProperty('pitch')) {
            pitchStyle = 'border-bottom:1px solid #9A86D6;'
        }

        ///////////////////////////////////////////////////////////////////////////
        // pause
        ///////////////////////////////////////////////////////////////////////////
        let pauseValue = 0
        let pauseColor = globalConfig.audioColor['pause']
        if (audiohumour.hasOwnProperty('pause')) {
            pauseValue = audiohumour['pause']


            // $(`<div class='pauseTech' style="height: 15px;  display:inline-block; position: relative; margin: 0px 2px -3px 2px; border-radius: 3px;"></div>`).insertBefore(selection.node())
            // //<i class='fas fa-square'></i>
            // d3.select(this.parentNode).select('.speed').style('margin-left', `${Math.ceil(pauseValue*10)}px`)
        }


        ///////////////////////////////////////////////////////////////////////////
        // text humor
        ///////////////////////////////////////////////////////////////////////////
        let texthumour = wordInfo['wordSkills']['texthumour']
            // console.log('texthumour: ', texthumour)

        ///////////////////////////////////////////////////////////////////////////
        // word, Alliteration_, Rhyme _, Polarity, Subjectivity(), 
        ///////////////////////////////////////////////////////////////////////////
        let eachWord = wordInfo.word
        let prev = ''
        let middle = wordInfo.word
        let last = ''
        let polarityStyle = ''
        if (texthumour['alliterations'].length > 0) {
            prev = eachWord.slice(0, 3)
            middle = eachWord.slice(3, )
        }
        if (texthumour['rhymes'].length > 0) {
            last = eachWord.slice(-3, eachWord.length)
                // middle = eachWord.slice(0, -3)
            middle = middle.slice(0, -3)
        }
        if (texthumour['polarity'].length > 0) {
            if (texthumour['polarity'][0] > 0) {
                polarityStyle = 'vertical-align: super;'
            } else {
                polarityStyle = 'vertical-align: sub;'
            }
        }
        if ((eachWord.length <= 6) & (texthumour['alliterations'].length > 0) & (texthumour['rhymes'].length > 0)) {
            prev = eachWord
            middle = ''
            last = ''
        }
        if (texthumour['subjectivity'].length > 0) {
            eachWord = `<span style="${polarityStyle}">(<U>${prev}</U>${middle}<U>${last}</U>)</span>`
        } else {
            eachWord = `<span style="${polarityStyle}"><U>${prev}</U>${middle}<U>${last}</U></span>`
        }

        let selection = d3.select(this)
            // selection.html(`<div class="outerWord"><div class="incongruity"></div><div class="speed" style="color:${speedColor}; margin-left: ${Math.ceil(pauseValue*10)}px;">${speedSymbol}</div><div class="innerWord"><div class="pause" style="width: ${Math.ceil(pauseValue*10)}px; background-color: ${pauseColor};"></div><div class="eachWord" style="${pitchStyle}">${eachWord}</div><div class="volume" style="color: ${volColor};">${volSymbol}</div></div></div>`)
            // adjust speed css
        selection.html(`<div class="outerWord"><div class="incongruity"></div><div class="speed" style="color:${speedColor}; position: absolute; margin-top:12px; display: inline-block;">${speedSymbol}</div><div class="innerWord"><div class="pause" style="width: ${Math.ceil(pauseValue*10)}px; background-color: ${pauseColor};"></div><div class="eachWord" style="${pitchStyle}">${eachWord}</div><div class="volume" style="color: ${volColor};">${volSymbol}</div></div></div>`)

        $(this).find(".speed").css("margin-left", $(this).width() / 3 + "px");

        ///////////////////////////////////////////////////////////////////////////
        // Repetition, Disconnection
        ///////////////////////////////////////////////////////////////////////////
        repetitionFlag['sentenceIdx'] = wordInfo.sIdx
        disconnectionFlag['sentenceIdx'] = wordInfo.sIdx
        if (texthumour['repetition'].length > 0 || texthumour['disconnection'].length > 0) {

            // let incongruityWidth = wordInfo.word.length * 7
            let incongruityWidth = 40;
            let incongruityHeight = 12
            let incongruitySvg = selection.select('.incongruity')
                .append('svg')
                .attr('width', incongruityWidth)
                .attr('height', incongruityHeight)

            // incongruitySvg.append('rect')
            //     .attr('width', incongruityWidth)
            //     .attr('height', incongruityHeight)
            //     .style('background-color', 'red')
            //     .style('opacity', 0.1)

            // redo f01e   redo-alt  f2f9
            // undo f0e2   undo-alt f2ea
            let rep_discon_flag = -1;
            if ((wordInfo['repetition'] == 2 && texthumour['repetition'].length > 0) & (wordInfo['disconnection'] == 2 && texthumour['disconnection'].length > 0)) {
                rep_discon_flag = 0;
            }

            if (wordInfo['repetition'] == 2 && texthumour['repetition'].length > 0) {
                incongruitySvg.append('g')
                    .attr('class', 'repetitionG')
                    // .attr('transform', 'translate(' + 0 + ', ' + 0.8*incongruityHeight + ')')
                    .attr('transform', function() {
                        if (rep_discon_flag == 0) {
                            return 'translate(0,10) scale(0.8)'
                        } else {
                            return 'translate(10,10) scale(0.8)'
                        }
                    })
                    .append('text')
                    // .attr('text-anchor', 'left')
                    .attr('class', 'fa')
                    .attr('font-size', '5px')
                    .attr('font-weight', 'lighter')
                    // .attr('color', 'red')
                    .text(function() {
                        if (repetitionFlag['repetition'] == 0) {
                            repetitionFlag['repetition'] += 1
                            return '\uf01e'
                        } else {
                            repetitionFlag['repetition'] = 0
                            return '\uf0e2'
                        }

                    })
                    .style('fill', globalConfig.textHumorColor['repetition'])
            }

            if (wordInfo['disconnection'] == 2 && texthumour['disconnection'].length > 0) {
                // let disconnectionG = incongruitySvg.append('g')
                //     .attr('class', 'disconnectionG')
                //     .attr('transform', 'translate(' + incongruityWidth/2 + ', ' + incongruityHeight/2 + ')')
                let disconnectionG = incongruitySvg.append('g')
                    .attr('class', 'disconnectionG')

                if (rep_discon_flag == 0) {
                    disconnectionG.attr('transform', 'translate(' + incongruityWidth / 2 + ', ' + (5) + ') scale(0.8)');
                } else {
                    disconnectionG.attr('transform', 'translate(10,5) scale(0.8)');
                }

                let defs = disconnectionG.append('defs')

                defs.append('marker')
                    .attr('id', 'arrow')
                    .attr('viewBox', '0 -5 10 10')
                    .attr('refX', 5)
                    .attr('refY', 0)
                    .attr('markerWidth', 4)
                    .attr('markerHeight', 4)
                    .attr('orient', 'auto')
                    .append('path')
                    .attr('d', 'M0,-5L10,0L0,5')
                    .attr('class', 'arrowHead')
                    .style("fill", globalConfig.textHumorColor['disconnection'])

                let cx = 0
                let x1 = 0
                let x2 = 0.4 * incongruityWidth
                if (disconnectionFlag['disconnection'] == 0) {
                    disconnectionFlag['disconnection'] += 1
                    cx = 0
                    x1 = 0
                    x2 = 0.4 * incongruityWidth
                } else {
                    disconnectionFlag['disconnection'] = 0
                    cx = 0.4 * incongruityWidth
                    x1 = 0.4 * incongruityWidth
                    x2 = 0
                }

                disconnectionG.append('circle')
                    .attr('cx', cx)
                    .attr('cy', 0)
                    .attr('r', 4)
                    .attr('fill', globalConfig.textHumorColor['disconnection'])

                disconnectionG.append('line')
                    .attr('x1', x1)
                    .attr('y1', 0)
                    .attr('x2', x2)
                    .attr('y2', 0)
                    .attr('marker-end', 'url(#arrowX)')
                    .style("stroke-dasharray", ("3, 3"))
                    .style('stroke', globalConfig.textHumorColor['disconnection'])
                    .style('stroke-width', '2px')
            }

        }

    }

    $('.scrollContent').scroll(function() {
        // console.log('scroll: ', $('.scrollContent').scrollTop())
        // let curTableTop = $('.scrollContent').scrollTop()
        // console.log('curTableTop: ', curTableTop)

        for (let i = 0; i < $('.tableRow').length; i++) {
            let elePosition = $(`.tableRow.row-${i}`).position().top - 30
            let elePositionStart = elePosition
            let elePositionEnd = elePositionStart + $(`.tableRow.row-${i}`).height()
            if (elePositionEnd >= 0) {
                let startTime = d3.select(`.tableRow.row-${i}`).data()[0]['startTime']
                _this.timeslider
                    .transition()
                    .duration(200)
                    .attr('d', () => {
                        let d = 'M' + (_this.previewContextMargin.left - 5) + ',' + (_this.yScaler(startTime) + _this.previewContextMargin.top)
                            ///////////////////////////////////////////////////////////////////////
                            //  OLD
                            // d += ' ' + (_this.previewContextWidth+5) + ',' + (_this.yScaler(startTime) + _this.previewContextMargin.top)
                            ///////////////////////////////////////////////////////////////////////
                        d += ' ' + (200 + 5) + ',' + (_this.yScaler(startTime) + _this.previewContextMargin.top)

                        return d
                    })
                break
            }
        }
    })
}
export default DrawUserFilter;